export default __webpack_public_path__ + "static/media/logo.57256e9c.svg";